<div class="field">
    <div class="tooltip" *ngIf="!isNAValue">
        <input type="number" [ngModel]="currentValue" (ngModelChange)="onCurrentValueChange($event)" [ngClass]="{
        'changed': modelValue?.isFieldChanged(property),
        'error': hasErrors()
    }" [disabled]="isDisabled" (change)="handleValueChange()" (input)="handleManualChange()" />
        <button mat-raised-button [disabled]="readOnly" class="mat-button-base na-button small-na-button"
            (click)="setNAFieldValue()">N/A</button>
        <div class="tooltiptext" *ngIf="errorMessages?.length">
            <div *ngFor="let error of errorMessages">{{error}}</div>
        </div>
    </div>
    <div class="na-button-container" *ngIf="isNAValue">
        <button mat-raised-button class="mat-button-base na-button" (click)="setZeroFieldValue()"
            [disabled]="isDisabled" color="primary">N/A</button>
    </div>
        <calibration-set-table-field-attributes *ngIf="!hideAttributeButtons" [identifiers]="getCalibrationSetTableFieldIdentifier()" [showPopover]="true"
        [attributePopupTitleDetails]="attributePopupTitleDetails">
    </calibration-set-table-field-attributes>
</div>
